const initialState = {
    history: [],
    count: {},
    isReadingHistory: false,
}

export default initialState;
